var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66672 2C9.66672 1.44772 10.1144 1 10.6667 1H13.3334C13.8857 1 14.3334 1.44772 14.3334 2V2.92578C14.3334 3.36819 14.6267 3.75216 15.0373 3.9168C15.0965 3.94051 15.1553 3.96489 15.2137 3.98994C15.6206 4.16426 16.0997 4.10023 16.4126 3.78728L17.0675 3.1324C17.458 2.74188 18.0912 2.74187 18.4817 3.1324L20.3673 5.01802C20.7579 5.40854 20.7579 6.04171 20.3673 6.43223L19.7125 7.08705C19.3996 7.40001 19.3355 7.87915 19.5099 8.28596C19.535 8.34454 19.5594 8.40347 19.5832 8.46275C19.7478 8.8734 20.1318 9.16672 20.5742 9.16672H21.5C22.0523 9.16672 22.5 9.61444 22.5 10.1667V12.8334C22.5 13.3857 22.0523 13.8334 21.5 13.8334H20.5741C20.1317 13.8334 19.7477 14.1267 19.5831 14.5373C19.5594 14.5964 19.5351 14.6551 19.5101 14.7134C19.3358 15.1202 19.3998 15.5993 19.7128 15.9123L20.3673 16.5669C20.7579 16.9574 20.7579 17.5906 20.3673 17.9811L18.4817 19.8667C18.0912 20.2572 17.458 20.2572 17.0675 19.8667L16.4132 19.2124C16.1002 18.8994 15.6211 18.8354 15.2142 19.0097C15.1556 19.0349 15.0966 19.0593 15.0373 19.0831C14.6267 19.2477 14.3334 19.6317 14.3334 20.0741V21C14.3334 21.5523 13.8857 22 13.3334 22H10.6667C10.1144 22 9.66672 21.5523 9.66672 21V20.0742C9.66672 19.6318 9.3734 19.2478 8.96275 19.0832C8.90347 19.0594 8.84454 19.035 8.78596 19.0099C8.37915 18.8355 7.90001 18.8996 7.58705 19.2125L6.93231 19.8673C6.54179 20.2578 5.90862 20.2578 5.5181 19.8673L3.63248 17.9816C3.24196 17.5911 3.24196 16.958 3.63248 16.5674L4.28728 15.9126C4.60023 15.5997 4.66426 15.1206 4.48994 14.7137C4.46489 14.6553 4.44051 14.5965 4.41679 14.5373C4.25216 14.1267 3.86819 13.8334 3.42578 13.8334H2.5C1.94772 13.8334 1.5 13.3857 1.5 12.8334V10.1667C1.5 9.61444 1.94772 9.16672 2.5 9.16672H3.42569C3.86811 9.16672 4.25209 8.8734 4.41672 8.46275C4.44052 8.40337 4.465 8.34433 4.49015 8.28566C4.6645 7.87883 4.60049 7.39967 4.28751 7.0867L3.63248 6.43167C3.24196 6.04115 3.24196 5.40798 3.63248 5.01746L5.5181 3.13184C5.90863 2.74132 6.54179 2.74132 6.93232 3.13184L7.5876 3.78713C7.90054 4.10007 8.37965 4.1641 8.78645 3.98981C8.84486 3.96478 8.90364 3.94041 8.96275 3.91672C9.3734 3.75209 9.66672 3.36811 9.66672 2.92569V2Z",
    fill: "#A3B0B3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4144_44765)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.4998,
    r: 3.5,
    stroke: "url(#paint0_radial_4144_44765)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4144_44765",
    x: 5.5,
    y: 4.99976,
    width: 13,
    height: 13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4144_44765"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4144_44765",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4144_44765",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.3557 6.17153) rotate(90) scale(10.0558 7.59679)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#F5F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#E4E4E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/cog.4239897b800697a070853f0de3bcc2f5.svg";
export { ForwardRef as ReactComponent };